import { useMemo } from 'react';

import { useSearchHeaderHeightContext } from '~/providers/SearchHeaderHeightProvider';

/**
 * tableHeaderTopPos: in table view, the header is sticky except in mobile. It accounts for other sticky things above it.
 */
export function useTableHeaderPosition() {
  const { searchHeaderHeight, viewControlsHeight } = useSearchHeaderHeightContext();

  const tableHeaderTopPos = useMemo(() => {
    return searchHeaderHeight + viewControlsHeight;
  }, [searchHeaderHeight, viewControlsHeight]);

  return { tableHeaderTopPos };
}
